/**
 * Remove accents from string
 * @param str str to filter
 * @returns normalized str
 */
function removeAccents(str?: string) {
  return str?.normalize('NFD').replace(/\p{Diacritic}/gu, '');
}

export default removeAccents;
